/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsSummaryDto } from '../../models/analytics-summary-dto';

export interface AnalyticsAdminControllerGetSummaryV1$Params {

/**
 * 조회 시작일
 */
  startDate: string;

/**
 * 조회 종료일
 */
  endDate: string;
}

export function analyticsAdminControllerGetSummaryV1(http: HttpClient, rootUrl: string, params: AnalyticsAdminControllerGetSummaryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, analyticsAdminControllerGetSummaryV1.PATH, 'get');
  if (params) {
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnalyticsSummaryDto>;
    })
  );
}

analyticsAdminControllerGetSummaryV1.PATH = '/api/v1/analytics/admin/summary';
